import { ModelApiService } from './BaseApiService'

export default class SearchBookingsApiService extends ModelApiService {
  constructor() {
    super('search-bookings')
  }

  async search(payload) {
    return await this.post(`search`, payload)
  }

  async getExportBookingData(payload) {
    return await this.post(`export-booking`, payload)
  }
}
